export class ManagedPropertyConfig {
  newsChannelManagedProperty: string;
  newsLanguageManagedProperty: string;
  newsIsTopNewsManagedProperty: string;
  newsAmountOfCommentsManagedProperty: string;
  newsAmountOfLikesManagedProperty: string;
  birthDayDateManagedProperty: string;
  newsSenderTagsManagedProperty: string;
  newsIsArchivedManagedProperty: string;
}

export class ManagedProperties {
  public static DefaultConfig: ManagedPropertyConfig = {
    newsChannelManagedProperty: 'RefinableString20', // Maps to ows_taxId_BoolField_Channel

    newsLanguageManagedProperty: 'RefinableString21', // Maps to ows_taxId_BoolField_Language

    newsIsTopNewsManagedProperty: 'BoolFieldNewsIsTopNewsOWSBOOL', // Maps to ows_q_BOOL_BoolField_NewsIsTopNews

    newsAmountOfCommentsManagedProperty: 'RefinableInt00', // Maps to ows__CommentCount

    newsAmountOfLikesManagedProperty: 'RefinableInt01', // Maps to ows__LikeCount

    birthDayDateManagedProperty: 'RefinableDate19', // Maps to People:SPS-Birthday

    newsSenderTagsManagedProperty: 'RefinableString22', // Maps to ows_taxId_BoolField_SenderTag

    newsIsArchivedManagedProperty: 'RefinableString23', // Maps to ows_q_BOOL_BoolField_Archive
  };
}
